import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserCallsToAction = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [
        ...userColumns,
        {
            field: 'viewCallToActionDatetime',
            name: 'Viewed Date ({tz} time zone)',
            dataType: 'datetime',
        },
        {
            field: 'clickCallToActionDatetime',
            name: 'Clicked Date ({tz} time zone)',
            dataType: 'datetime',
        },
        {
            field: 'callToActionTitle',
            name: 'Call To Action Title',
            dataType: 'multiselect',
        },
        {
            field: 'resourceTitle',
            name: 'Linked Resource Title',
            dataType: 'multiselect',
            styles: { minWidth: '20rem' },
        },
    ];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.callToActionDate),
    //     {
    //         count: true,
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Calls To Action',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="User Calls To Action Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows detailed information about user interactions with
                    calls-to-action elements throughout the application.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Viewed Date">
                    When the user viewed or was presented with the call-to-action element.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Clicked Date">
                    When the user actually clicked on the call-to-action. May be empty if
                    the call-to-action was viewed but not clicked.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Call To Action Title">
                    The name or title of the specific call-to-action element that the user
                    interacted with.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Linked Resource Title">
                    The title of the resource that the call-to-action links to or
                    references. If the linked content is an external resource, it will
                    have the fallback value of "Dashboard CTA".
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserCallsToAction;
